import { SelectItem } from '@mantine/core';
import { BankList } from '../enums/bank.enums';
import { BusinessTypes, BusinessTypesText } from '../enums/business-type';

export const getBusinessTypeId = (
  businessTypeText: BusinessTypesText
): BusinessTypes => {
  const index = Object.values(BusinessTypesText).indexOf(businessTypeText);
  const key = Object.keys(BusinessTypesText)[index];

  return BusinessTypes[key as keyof typeof BusinessTypes];
};

export const ConvertEnumToStringArray = (enm: {
  [s: string]: any;
}): string[] => {
  return Object.values(enm).filter(
    (value) => typeof value === 'string'
  ) as string[];
};

export const ConvertEnumToSelectItemArray = (enm: {
  [s: string]: any;
}): SelectItem[] => {
  return Object.values(enm)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      value: key,
      label: key.replace(/_/g, ' '),
    }));
};

export const GetBankNamesData = (): SelectItem[] => {
  return ConvertEnumToSelectItemArray(BankList).filter((value) => {
    return value.value !== BankList.PAYMAYA && value.value !== BankList.GCASH;
  });
};
